

export function transposeTable<T>(table: T[][]): T[][] {
    return table[0].map((_, colIndex) => table.map(row => row[colIndex]));
}
